/**
 * Portal Home hub copy — re-exports shared SSOT + portal-only orientation helpers.
 */

export {
  ATTENTION_EMPTY,
  SEND_TITLE,
  SEND_SUBCOPY,
  NAV_SHARED_DOCUMENTS,
  PUBLISHED_BRIEF_CAPTION,
  trustEmptyCopy,
  EMPTY_DOCUMENTS_TITLE,
  EMPTY_DOCUMENTS,
  EMPTY_FOR_REVIEW_TITLE,
  EMPTY_FOR_REVIEW,
  EMPTY_PUBLISHED_TITLE,
  EMPTY_PUBLISHED,
  EMPTY_PROJECT_PLAN_TITLE,
  EMPTY_PROJECT_PLAN,
  EMPTY_ENGAGEMENT_MILESTONES,
  EMPTY_PROGRAMME,
  SHARED_WITH_YOU,
  SENT_BY_YOU,
  HOME_GREETING,
  contactLine,
  GOP_PORTAL_WELCOME_GUIDE,
  PORTAL_HELP_TITLE,
  PORTAL_HELP_AREAS_HEADING,
  PORTAL_HELP_AREAS,
  PORTAL_HELP_SIGN_IN_HEADING,
  PORTAL_HELP_SIGN_IN_BULLETS,
  PORTAL_HELP_REPLAY_LABEL,
  PORTAL_HELP_REPLAY_HINT,
  PORTAL_HELP_CONTACT_HEADING,
  PORTAL_HELP_CONTACT_FALLBACK,
  PAGE_CAPTIONS,
  EMPTY_WORKING_GROUPS,
} from "@l30/shared";

/** sessionStorage key — mirrors `t33WelcomeEntered` pattern. */
export const ORIENTATION_SESSION_KEY = "t33OrientationSeen";

export const ORIENTATION_TITLE = "Your workspace";

export const ORIENTATION_JOBS = [
  {
    id: "attend",
    title: "Attend to requests",
    description: "Reviews, signatures, and decisions waiting for you",
  },
  {
    id: "programme",
    title: "Follow the programme",
    description: "Brief, plan, and milestones",
  },
  {
    id: "send",
    title: "Send materials",
    description: "Messages and files to Latitude30",
  },
] as const;

export const ORIENTATION_CONTINUE = "Continue to workspace";

export function isOrientationSeen(storage: Pick<Storage, "getItem">): boolean {
  try {
    return storage.getItem(ORIENTATION_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function markOrientationSeen(storage: Pick<Storage, "setItem">): void {
  try {
    storage.setItem(ORIENTATION_SESSION_KEY, "1");
  } catch {
    /* sessionStorage unavailable — dismiss in-memory for this mount */
  }
}

export function clearOrientationSeen(storage: Pick<Storage, "removeItem">): void {
  try {
    storage.removeItem(ORIENTATION_SESSION_KEY);
  } catch {
    /* sessionStorage unavailable */
  }
}
